<ag-grid-angular
  style="width: 100%"
  class="ag-theme-alpine"
  [animateRows]="true"
  [columnDefs]="columnDefs"
  [context]="context"
  style="height: calc(65vh - 160px)"
  [overlayNoRowsTemplate]="overlayNoRowsTemplate"
  [rowData]="rowData"
  [rowDragManaged]="rowDragManaged"
  [rowSelection]="{ mode: 'multiRow', enableClickSelection: false, selectAll: 'filtered' }"
  [suppressRowDrag]="suppressRowDrag"
  [stopEditingWhenCellsLoseFocus]="true"
  (cellValueChanged)="onCellValueChanged($event)"
  (gridReady)="onGridReady($event)"
  (rowDragEnter)="onRowDragEnter($event)"
  (rowDragEnd)="onRowDragEnd($event)"
  (selectionChanged)="onSelectionChanged($event)"
></ag-grid-angular>
